import { resolveNodeType } from './nodeConfig';
import type { ProjectDocument } from '../types/project';

// ------------------------------------------------------------
// Human-readable validation messages
// ------------------------------------------------------------

export function collectProductTypeLabels(
  document: ProjectDocument | null,
): Map<string, string> {
  const labels = new Map<string, string>();
  if (!document) return labels;

  for (const node of document.nodes) {
    if (resolveNodeType(node) !== 'input') continue;
    const productTypes =
      (node.product_types as Array<{ id: string; name: string }> | undefined) ??
      [];
    for (const productType of productTypes) {
      if (!productType.id) continue;
      labels.set(productType.id, productType.name?.trim() || productType.id);
    }
  }

  return labels;
}

export function humanizeValidationMessage(
  message: string,
  productLabels: Map<string, string>,
): string {
  let result = message;
  for (const [id, label] of productLabels) {
    if (!id || id === label) continue;
    result = result.split(`'${id}'`).join(`'${label}'`);
    result = result.split(`"${id}"`).join(`"${label}"`);
  }
  return result;
}
